// FontAwesome 아이콘 등록 (트리쉐이킹 위해 필요한 것만)
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faGauge,
  faIndustry,
  faClipboardList,
  faMicrochip,
  faMagnifyingGlassChart,
  faChartLine,
  faBell,
  faBolt,
  faShieldHalved,
  faLock,
  faUser,
  faRightFromBracket,
  faMoon,
  faSun,
  faBars,
  faXmark,
  faArrowRight,
  faArrowUpRightFromSquare,
  faCheck,
  faCircleCheck,
  faCircleExclamation,
  faCircleNotch,
  faPlus,
  faRotate,
  faPlay,
  faPause,
  faTriangleExclamation,
  faCirclePlus,
  faCircleInfo,
  faRobot,
  faGears,
  faServer,
  faTowerBroadcast,
  faRulerCombined,
  faCubes,
  faSliders,
  faSitemap,
  faChartArea,
  faTowerObservation,
  faLink,
  faArrowsTurnToDots,
  faClock,
  faUserCheck,
  faBoxesStacked,
  faWrench,
  faUsers,
  faRightToBracket,
  faStopwatch,
  faClipboardCheck,
  faListCheck,
  faCalendarDays,
  faCalculator,
  faMoneyBillTrendUp,
  faScaleBalanced,
  faWarehouse,
  faArrowsLeftRightToLine,
  faMinus,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faGauge,
  faIndustry,
  faClipboardList,
  faMicrochip,
  faMagnifyingGlassChart,
  faChartLine,
  faBell,
  faBolt,
  faShieldHalved,
  faLock,
  faUser,
  faRightFromBracket,
  faMoon,
  faSun,
  faBars,
  faXmark,
  faArrowRight,
  faArrowUpRightFromSquare,
  faCheck,
  faCircleCheck,
  faCircleExclamation,
  faCircleNotch,
  faPlus,
  faRotate,
  faPlay,
  faPause,
  faTriangleExclamation,
  faCirclePlus,
  faCircleInfo,
  faRobot,
  faGears,
  faServer,
  faTowerBroadcast,
  faRulerCombined,
  faCubes,
  faSliders,
  faSitemap,
  faChartArea,
  faTowerObservation,
  faLink,
  faArrowsTurnToDots,
  faClock,
  faUserCheck,
  faBoxesStacked,
  faWrench,
  faUsers,
  faRightToBracket,
  faStopwatch,
  faClipboardCheck,
  faListCheck,
  faCalendarDays,
  faCalculator,
  faMoneyBillTrendUp,
  faScaleBalanced,
  faWarehouse,
  faArrowsLeftRightToLine,
  faMinus,
  faChevronDown,
)
